import { useEffect } from "react";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { createContext, useContext, useState } from "react";

const TenantCtx = createContext(null);

export function TenantProvider({ children }) {
  const { status } = useAuth();
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (status !== "authed") {
      setTenant(null);
      return;
    }
    setLoading(true);
    api.get("/tenant/me")
      .then((r) => setTenant(r.data))
      .catch(() => setTenant(null))
      .finally(() => setLoading(false));
  }, [status]);

  const refresh = async () => {
    try {
      const r = await api.get("/tenant/me");
      setTenant(r.data);
    } catch { /* ignore */ }
  };

  return (
    <TenantCtx.Provider value={{ tenant, loading, refresh }}>
      {children}
    </TenantCtx.Provider>
  );
}

export const useTenant = () => useContext(TenantCtx) || {};
